// Directionally-aware header with GSAP.
// Hides on scroll-down, reveals on scroll-up.

(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var header = document.querySelector('.header');
    if (!header) return;

    var HIDE_THRESHOLD  = 10;   // px downward accumulation before hiding
    var SHOW_THRESHOLD  = 6;    // px upward accumulation before revealing
    var ALWAYS_SHOW_TOP = 80;   // always visible within this many px of the top

    var lastY       = window.scrollY;
    var accumulated = 0;
    var hidden      = false;

    var showTween = gsap.to(header, { y: '0%',    duration: 0.45, ease: 'power3.out', paused: true, overwrite: true });
    var hideTween = gsap.to(header, { y: '-100%', duration: 0.45, ease: 'power3.in',  paused: true, overwrite: true });

    function reveal() {
      if (!hidden) return;
      hidden = false;
      header.classList.remove('is-hidden');
      hideTween.pause();
      showTween.restart();
    }

    var cartDot = document.querySelector('.header__cart-dot');
    function cartHasItems() {
      return cartDot && cartDot.classList.contains('is-visible');
    }

    function conceal() {
      if (hidden) return;
      if (cartHasItems()) return;
      hidden = true;
      header.classList.add('is-hidden');
      showTween.pause();
      hideTween.restart();
    }

    document.addEventListener('cart:change', function (e) {
      var count = e.detail && e.detail.cart && e.detail.cart.item_count;
      if (count > 0) reveal();
    });

    // On touch, inertia keeps firing scroll events after the finger lifts.
    // Reset the accumulator on each new touch so upward swipes reveal immediately.
    window.addEventListener('touchstart', function () {
      accumulated = 0;
      lastY = Math.max(0, window.scrollY);
    }, { passive: true });

    window.addEventListener('scroll', function () {
      var y     = Math.max(0, window.scrollY);
      var delta = y - lastY;
      lastY     = y;

      if (y < ALWAYS_SHOW_TOP) {
        reveal();
        accumulated = 0;
        return;
      }

      accumulated += delta;

      if (accumulated > HIDE_THRESHOLD) {
        conceal();
        accumulated = 0;
      } else if (accumulated < -SHOW_THRESHOLD) {
        reveal();
        accumulated = 0;
      }
    }, { passive: true });
  }

  function loadGSAP(cb) {
    if (window.gsap) { cb(); return; }
    if (window.__swGsapPending) { document.addEventListener('sw:gsap', cb, { once: true }); return; }
    window.__swGsapPending = true;
    var s = document.createElement('script');
    s.src = window.__swGsapUrl;
    s.onload = function () {
      window.__swGsapLoaded = true;
      document.dispatchEvent(new CustomEvent('sw:gsap'));
      cb();
    };
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { loadGSAP(init); });
  } else {
    loadGSAP(init);
  }
})();
